<!-- Reports tab: report selector + PDF preview -->
<div class="h-full w-full flex flex-col relative overflow-hidden gap-2 p-2">

    <!-- Report selector dropdown -->
    <div>
        <app-select
            class="w-full"
            [options]="$any(reportMenuItems)"
            [(value)]="selectedReportValue"
            (onChange)="onReportSelectChange($event)"
            [config]="{ placeholder: 'Select report', showClear: false }">
        </app-select>
    </div>

    <!-- PDF viewer – shown only when a report is selected -->
    @if (selectedReportDocument) {
    <div class="flex-1 min-h-0">
        <app-pdf-viewer
            class="h-full w-full rounded-xl"
            [pdfUrl]="selectedReportDocument.url"
            [initialPage]="selectedReportDocument.pageNumber ?? 1"
            [title]="selectedReportDocument.name"
            [hideToolbar]="false">
        </app-pdf-viewer>
    </div>
    } @else {
    <!-- Empty state when no reports are available -->
    <div class="flex flex-col items-center justify-center flex-1 gap-3 text-gray-400">
        <img class="w-32 opacity-50" [src]="'images/bob_agent/top-left-point-bob.svg' | assetUrl" alt="" draggable="false" />
        <p class="text-sm">No reports available</p>
    </div>
    }
</div>
